import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';
import { toast } from 'sonner';

export default function CoachOnboarding() {
  const [teamName, setTeamName] = useState('');
  const [level, setLevel] = useState('');
  const [seasonName, setSeasonName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/teams', {
        name: teamName,
        level,
        season_name: seasonName,
      });
      
      toast.success('Team created!');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Failed to create team');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 p-4">
      <div className="max-w-2xl mx-auto py-12">
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight uppercase font-heading text-slate-900 mb-2">
            Create Your Team
          </h1>
          <p className="text-lg text-slate-600">Set up your first team and season</p>
        </div>

        <div className="bg-white border border-slate-200 rounded-lg shadow-md p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="teamName" className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
                Team Name
              </Label>
              <Input
                id="teamName"
                data-testid="team-name-input"
                value={teamName}
                onChange={(e) => setTeamName(e.target.value)}
                placeholder="e.g., Warriors U14"
                required
                className="h-12 bg-white border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            <div>
              <Label htmlFor="level" className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
                Level / Age Group
              </Label>
              <Input
                id="level"
                data-testid="level-input"
                value={level}
                onChange={(e) => setLevel(e.target.value)}
                placeholder="e.g., U14, High School Varsity"
                required
                className="h-12 bg-white border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            <div>
              <Label htmlFor="seasonName" className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
                Season Name
              </Label>
              <Input
                id="seasonName"
                data-testid="season-name-input"
                value={seasonName}
                onChange={(e) => setSeasonName(e.target.value)}
                placeholder="e.g., 2025-26 Season"
                required
                className="h-12 bg-white border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="create-team-button"
              className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-bold uppercase tracking-wide shadow-md hover:shadow-lg transition-all active:scale-95"
            >
              {loading ? 'Creating...' : 'Create Team'}
            </Button>
          </form>
        </div>

        <div className="mt-6 text-center text-sm text-slate-600">
          <p>You can build your roster from the Teams page after this step.</p>
        </div>
      </div>
    </div>
  );
}
